import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { map, every } from 'lodash';
import classnames from 'classnames';
import {
  Modal, ModalBody, Button, TabContent, TabPane,
} from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  capitalizeEveryWord, FILTER_CATEGORY, ICON_TYPE,
} from '../../utils';

function FilterByBrand(props) {
  const {
    isOpen, onClose, categoryData, filterByBrands, lastClickedIndex, updateLastClickedIndex,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const [brands, setBrands] = useState(categoryData);
  const [activeTab, setActiveTab] = useState(categoryData[lastClickedIndex].name);
  const [selectedTab, setSelectTab] = useState([categoryData[lastClickedIndex]]);
  const [lastCategoryClicked, setLastCategoryClicked] = useState();

  const toggleCategory = useCallback((tab, index) => {
    if (activeTab !== tab.name) {
      setSelectTab(tab);
      setActiveTab(tab.name);
      setLastCategoryClicked(index);
    }
  }, [activeTab]);

  const selectCategory = useCallback((event, item, type, subCategory) => {
    let checkedBrands;
    switch (type) {
      case FILTER_CATEGORY.CATEGORY:
        checkedBrands = map(brands, (ele) => {
          if (ele._id === item._id) {
            ele.isChecked = event.target.checked;
            if (!ele.isChecked) {
              map(item.subCategoryId, (subEle) => {
                subEle.isSubCategoryChecked = ele.isChecked;
              });
              ele.isAllChecked = ele.isChecked;
            }
          }
          return ele;
        });
        setBrands(checkedBrands);
        setSelectTab(item);
        break;
      case FILTER_CATEGORY.SUB_CATEGORY:
        checkedBrands = map(brands, (ele) => {
          if (ele._id === item._id) {
            map(item.subCategoryId, (subEle) => {
              if (subEle._id === subCategory._id) {
                subEle.isSubCategoryChecked = event.target.checked;
              }
            });
            const isValueChecked = item.subCategoryId.some((obj) => Boolean(obj.isSubCategoryChecked));
            ele.isChecked = event.target.checked ? event.target.checked : isValueChecked;
            ele.isAllChecked = every(item.subCategoryId, ['isSubCategoryChecked', true]);
          }
          return ele;
        });
        setBrands(checkedBrands);
        // setSelectTab(item);
        setActiveTab(item.name);
        break;
      case FILTER_CATEGORY.ALL:
        checkedBrands = map(brands, (ele) => {
          if (ele._id === item._id) {
            ele.isChecked = event.target.checked;
            ele.isAllChecked = event.target.checked;
            map(item.subCategoryId, (subEle) => {
              subEle.isSubCategoryChecked = event.target.checked;
            });
          }
          return ele;
        });
        setBrands(checkedBrands);
        // setSelectTab(item);
        setActiveTab(item.name);
        break;
      default:
        break;
    }
  }, [brands]);

  const hideModal = () => {
    toggle();
    onClose();
  };

  const renderCategoryListing = useCallback(() => map(brands, (item, index) => item && (
    <div
      key={`category-${index}`}
      className={`modal-filter-category-row ${classnames({ active: activeTab === item.name })}`}
      onClick={() => toggleCategory(item, index)}
    >
      <label htmlFor={`category-${index}`} className="input-container-green">
        <input
          id={`category-${index}`}
          type="checkbox"
          onClick={(event) => selectCategory(event, item, FILTER_CATEGORY.CATEGORY)}
          checked={!!item.isChecked}
        />
        <span className="checkmark" />
      </label>
      {capitalizeEveryWord(item.name)}
    </div>
  )), [brands, activeTab, selectCategory, toggleCategory]);

  const renderSubCategory = useCallback(() => map(selectedTab.subCategoryId, (item, index) => item && (
    <>
      <label htmlFor={`subCategory-${index}`} className="input-container-blank" key={`subCategory-${index}`}>
        <input
          id={`subCategory-${index}`}
          type="checkbox"
          checked={!!item.isSubCategoryChecked}
          onClick={(event) => selectCategory(event, selectedTab, FILTER_CATEGORY.SUB_CATEGORY, item)}
        />
        <span className="checkmark">
          {item.name}
        </span>
      </label>
    </>
  )), [selectCategory, selectedTab]);

  const renderTabPane = () => (
    <TabPane className="modal-filter-content-wrapper" tabId={`${selectedTab.name}`}>
      <h2>
        <img
          src={ICON_TYPE[selectedTab.name]}
          alt={selectedTab.name}
        />
        {capitalizeEveryWord(selectedTab.name)}
        <label htmlFor={`${selectedTab.name}All`} className="input-container-blank">
          <input
            id={`${selectedTab.name}All`}
            type="checkbox"
            checked={!!selectedTab.isAllChecked}
            onClick={(event) => selectCategory(event, selectedTab, FILTER_CATEGORY.ALL)}
          />
          <span className="checkmark">
            All
          </span>
        </label>
      </h2>
      <div className="tag-container">{renderSubCategory()}</div>
    </TabPane>
  );

  const clearFilter = () => {
    const checkedBrands = map(brands, (ele) => {
      ele.isChecked = false;
      ele.isAllChecked = false;
      map(ele.subCategoryId, (subEle) => {
        subEle.isSubCategoryChecked = false;
      });
      return ele;
    });
    setBrands(checkedBrands);
    setActiveTab(checkedBrands[0].name);
    setSelectTab(checkedBrands[0]);
    updateLastClickedIndex(0);
    filterByBrands([]);
  };

  const applyFilter = () => {
    const filterArr = [];
    map(brands, (ele) => {
      if (ele.isChecked) {
        filterArr.push(ele);
      }
    });
    filterArr.length && filterByBrands(filterArr);
    filterArr.length && updateLastClickedIndex(lastCategoryClicked || lastClickedIndex);
    filterArr.length && onClose();
  };

  return (
    <Modal isOpen={modal} className="modal-filter modal-dialog-centered">
      <ModalBody>
        <div className="modal-filter-category">
          <h2>Select category</h2>
          <Scrollbars
            style={{ height: 'calc(100vh - 153px)' }}
            thumbMinSize={30}
          >
            {renderCategoryListing()}
          </Scrollbars>
        </div>
        <TabContent className="modal-filter-content" activeTab={activeTab}>
          <span
            className="icon icon-cross"
            onClick={hideModal}
          />
          <h4>Select brands under</h4>
          <Scrollbars
            style={{ height: 'calc(100vh - 210px)' }}
            thumbMinSize={30}
          >
            {renderTabPane()}
          </Scrollbars>
          <div className="modal-filter-btn-group">
            <span className="cursor-pointer" onClick={clearFilter}>Clear all</span>
            <Button
              color="accept"
              type="button"
              onClick={() => { applyFilter(); }}
            >
              Apply filter
            </Button>
          </div>
        </TabContent>
      </ModalBody>
    </Modal>
  );
}
FilterByBrand.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  categoryData: PropTypes.array.isRequired,
  filterByBrands: PropTypes.func.isRequired,
  lastClickedIndex: PropTypes.number.isRequired,
  updateLastClickedIndex: PropTypes.func.isRequired,
};
export default FilterByBrand;
